import { createFileRoute } from '@tanstack/react-router';

import { ContainersIndexView } from '../../../features/containers/containers-index-view';

export const Route = createFileRoute('/products/containers/')({
  component: ContainersIndexView,
});
